import { Input as ChakraInput, InputProps } from '@chakra-ui/input'
import { Box, InputGroup, BoxProps, InputRightElement } from '@chakra-ui/react'
import * as React from 'react'
import { useColor } from '../../../theme'
import { ErrorMessage } from '../ErrorMessage'
import { IFormValidationProps } from '../hooks'

interface IAutoSaveInputProps {
  autoSaveHandler?: () => Promise<void> | void
  containerProps?: BoxProps
  rightElement?: React.ReactElement
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>
  onKeyUp?: React.KeyboardEventHandler<HTMLInputElement>
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void

  inputRightElement?: React.ReactElement
}

export const AutoSaveInput = React.forwardRef<
  HTMLInputElement,
  IAutoSaveInputProps & IFormValidationProps & InputProps
>(
  (
    {
      autoSaveHandler,
      isInvalid,
      Label,
      errorMessage,
      isDisabled,
      placeholder,
      rightElement,
      containerProps,
      onChange,
      onKeyDown,
      onKeyUp,
      inputRightElement,
      ...rest
    },
    ref,
  ) => {
    const invalidColor = useColor({ nuance: 'red', palette: 'colors' })

    return (
      <Box
        alignContent="start"
        data-testid="input-container"
        display="grid"
        {...containerProps}>
        {Label && <Label />}

        <InputGroup data-testid="input-group">
          <ChakraInput
            backgroundColor="#EDEDF2"
            data-testid="input-field"
            errorBorderColor={invalidColor}
            fontSize="md"
            isDisabled={isDisabled}
            isInvalid={isInvalid}
            onChange={async (e: React.ChangeEvent<HTMLInputElement>) => {
              await onChange?.(e)
              await autoSaveHandler?.()
            }}
            onKeyDown={onKeyDown}
            onKeyUp={onKeyUp}
            placeholder={placeholder}
            ref={ref}
            {...rest}
          />

          {inputRightElement && <InputRightElement height="full">
            {inputRightElement}
          </InputRightElement>}

          {rightElement ? rightElement : ''}
        </InputGroup>

        {isInvalid && errorMessage && (
          <ErrorMessage isDisabled={isDisabled}>{errorMessage}</ErrorMessage>
        )}
      </Box>
    )
  },
)
